import { Share2, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";


const targets = (img, page, TEXT, title) => [
  ["facebook", "Facebook", `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(img)}`],
  ["pinterest", "Pinterest", `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(page)}&media=${encodeURIComponent(img)}&description=${encodeURIComponent(TEXT)}`],
  ["x", "X (Twitter)", `https://twitter.com/intent/tweet?text=${encodeURIComponent(TEXT)}&url=${encodeURIComponent(img)}`],
  ["email", "Email", `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${TEXT}\n${img}`)}`],
];

const nativeShare = async (card, img, TEXT) => {
  const blob = await (await fetch(card.src)).blob();
  const file = new File([blob], `BurrHaus-${card.name}.png`, { type: blob.type });
  if (navigator.canShare?.({ files: [file] })) await navigator.share({ files: [file], title: "NICE apology card", text: TEXT });
  else await navigator.share({ title: "NICE apology card", text: TEXT, url: img });
};

export const ShareCard = ({ card, page: pagePath }) => {
  const TEXT = `${card.title} — from NICE™, a Colorful Acorn Parenting™ Resource by BurrHaus Counseling`;
  const img = `${window.location.origin}${card.src}`;
  const page = `${window.location.origin}${pagePath || window.location.pathname}`;
  const copy = () => navigator.clipboard?.writeText(img).then(() => toast.success("Link copied"));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="pp-ghost" data-testid={`share-card-${card.name}`}><Share2 className="h-4 w-4" /> Post</button>
      </PopoverTrigger>
      <PopoverContent className="w-56 bg-white p-2" data-testid={`share-menu-${card.name}`}>
        {navigator.share && (
          <button className="pp-share-item" data-testid={`share-native-${card.name}`}
            onClick={() => nativeShare(card, img, TEXT).catch(() => {})}>
            Share to apps (Instagram, Messages…)
          </button>
        )}
        {targets(img, page, TEXT, card.title).map(([id, label, url]) => (
          <a key={id} href={url} target="_blank" rel="noreferrer" className="pp-share-item" data-testid={`share-${id}-${card.name}`}>{label}</a>
        ))}
        <button className="pp-share-item" onClick={copy} data-testid={`share-copy-${card.name}`}><Link2 className="h-4 w-4" /> Copy link</button>
      </PopoverContent>
    </Popover>
  );
};
